/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */

import { ApiResParserService } from '@api/services/api-res-parser/api-res-parser.service';
import { ApiService } from '@api/services/api/api.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import {
  LabelItemDTO,
  ChecklistDTO,
  PositionDTO,
  WizardDTO,
  SurveyDTO,
  DomainItemDTO,
  FormDTO,
  UserDataDTO,
  HawkScanDTO
} from '../../models';
import { environment } from '@environments/environment';

export interface DbUserDataDTO extends UserDataDTO {
  code: string;
}

export interface DbDomainItemDTO extends DomainItemDTO {
  code: string;
}

export interface DbWizardDTO extends WizardDTO {
  operation: string;
}

export interface DBStructure {
  userData?: DbUserDataDTO[];
  labels?: LabelItemDTO[];
  domains?: DbDomainItemDTO[];
  positions?: PositionDTO[];
  wizards?: DbWizardDTO[];
  surveys?: SurveyDTO[];
  forms?: FormDTO[];
  checklists?: ChecklistDTO[];
  scans?: HawkScanDTO[];
}

@Injectable({
  providedIn: 'root'
})
export class ApiDemoService extends ApiService {
  protected db: DBStructure;

  constructor(
    protected http: HttpClient,
    protected parser: ApiResParserService
  ) {
    super(http, parser);
  }

  protected loadDB(): Observable<DBStructure> {
    if (!!this.db && Object.keys(this.db).length > 0) {
      return of(this.db);
    }

    return this.getDB().pipe(
      map(db => {
        this.db = db;
        this.syncStorageDB();

        return db;
      })
    );
  }

  protected getDB(): Observable<DBStructure> {
    const demoDB = sessionStorage.getItem('demoDB');

    if (!!demoDB) {
      return of<DBStructure>(JSON.parse(demoDB));
    } else {
      return this.http.get(environment.demoDBUrl);
    }
  }

  protected syncStorageDB(): void {
    if (!this.db) {
      return;
    }

    const demoDB = JSON.stringify(this.db);

    sessionStorage.setItem('demoDB', demoDB);
  }

  private protected<T>(data: T, delayTime: number = 500): Observable<T> {
    let output = null;

    try {
      output = JSON.parse(JSON.stringify(data));
    } catch (_) {}

    return of(output).pipe(delay(delayTime));
  }
}
